export default {
    OBJECT_TYPE: "ObjectType",
    ID: "Id",
    COLOR: "Color",
    INPUT_LINKS_COUNT: "InputLinksCount",
    OUTPUT_LINKS_COUNT: "OutputLinksCount",
    PIN_ACTION: "PinAction"
};
